// extracted by mini-css-extract-plugin
module.exports = {"title":"SuccessModal_title__18RXc","container":"SuccessModal_container__2jkRe","subtitle":"SuccessModal_subtitle__HC6Cl","button":"SuccessModal_button__1XYA0"};